.fadeIn {
   transition: opacity 0.7s ease-in-out;
   display: block;
   opacity: 0;
}
.faddedIn {
   opacity: 1;
}
atlantis-icon::part(icon) {
    color: var(--tti-cookie-banner-icon);
}